/* ============================================================
   Header Horizon — assets/header-horizon.js
   - Scroll effect
   - Menu mobile (overlay plein écran)
   - Dropdowns langue / devise
   ============================================================ */
(function () {

  // ── Padding-top MainContent = hauteur totale du groupe fixe ─
  function updateOffsets() {
    var group  = document.querySelector('.hn-header-group');
    var groupH = group ? group.getBoundingClientRect().height : 72;

    // Padding-top = promo bar + navbar
    var main = document.getElementById('MainContent');
    if (main) main.style.paddingTop = groupH + 'px';

    // Variable CSS utile pour d'autres éléments (sticky, etc.)
    document.documentElement.style.setProperty('--hn-group-h', groupH + 'px');
  }

  updateOffsets();
  window.addEventListener('resize', updateOffsets, { passive: true });

  // ── Scroll effect : hide/show groupe + is-scrolled ─────────
  var group  = document.querySelector('.hn-header-group');
  var header = document.querySelector('.hn-header');

  if (group) {
    var lastScrollTop = 0;
    var isHidden      = false;
    var THRESHOLD     = 400;

    var onScroll = function () {
      var scrollTop = window.scrollY || window.pageYOffset;

      // is-scrolled sur le header (styles visuels)
      if (header) header.classList.toggle('is-scrolled', scrollTop > 10);

      if (scrollTop > THRESHOLD) {
        if (scrollTop > lastScrollTop) {
          if (!isHidden) {
            group.classList.add('is-hidden');
            isHidden = true;
          }
        } else {
          if (isHidden) {
            group.classList.remove('is-hidden');
            isHidden = false;
          }
        }
      } else {
        if (isHidden) {
          group.classList.remove('is-hidden');
          isHidden = false;
        }
      }

      lastScrollTop = scrollTop;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Menu mobile ──────────────────────────────────────────
  const hamburger  = document.querySelector('.hn-header__hamburger');
  const mobileNav  = document.getElementById('hn-mobile-nav');
  const closeBtn   = document.querySelector('.hn-menu__close');

  function openMenu() {
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.classList.add('is-active');
    document.body.classList.add('hn-nav-open');
    // Focus sur le bouton fermer pour l'accessibilité
    if (closeBtn) closeBtn.focus();
  }

  function closeMenu() {
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.classList.remove('is-active');
    document.body.classList.remove('hn-nav-open');
    hamburger.focus();
  }

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', openMenu);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeMenu);
  }

  // Fermer avec la touche Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // Fermer en cliquant sur un lien du menu
  if (mobileNav) {
    mobileNav.querySelectorAll('.hn-menu__link').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  // ── Dropdowns langue / devise ────────────────────────────
  // Langue et devise : select natif avec onchange="this.form.submit()"
  // Pas de JS custom nécessaire — le navigateur gère le submit nativement


  // ── Search drawer ────────────────────────────────────────
  const searchTrigger = document.getElementById('hn-search-trigger');
  const searchDrawer  = document.getElementById('hn-search-drawer');
  const searchClose   = document.getElementById('hn-search-close');
  const searchOverlay = document.getElementById('hn-search-overlay');
  const searchInput   = document.getElementById('hn-search-input');

  function openSearch() {
    searchDrawer.classList.add('is-open');
    searchDrawer.setAttribute('aria-hidden', 'false');
    if (searchTrigger) searchTrigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('hn-nav-open'); // bloque le scroll
    // Focus sur l'input après la transition
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
  }

  function closeSearch() {
    searchDrawer.classList.remove('is-open');
    searchDrawer.setAttribute('aria-hidden', 'true');
    if (searchTrigger) {
      searchTrigger.setAttribute('aria-expanded', 'false');
      searchTrigger.focus();
    }
    document.body.classList.remove('hn-nav-open');
  }

  if (searchTrigger && searchDrawer) {
    searchTrigger.addEventListener('click', openSearch);
  }

  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  if (searchOverlay) {
    searchOverlay.addEventListener('click', closeSearch);
  }

  // Fermer avec Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchDrawer && searchDrawer.classList.contains('is-open')) {
      closeSearch();
    }
  });

})();
